import React from "react";
import WithPropsAndLabels from "../WithPropsAndLabels";

const ConditionalField = ({condition,children,...props }) => {
    return condition(props.record) ? <WithPropsAndLabels {...props}>{children}</WithPropsAndLabels> : null;
};

export default ConditionalField;